export default "__VITE_ASSET__62cfcb24__"